export enum Color {
  /**
   * New colors
   */
  primary100 = '#ef4156',
  primary80 = '#e25f70',
  primary10 = '#fef0f2',
  secondary100 = '#2f4050',
  secondary10 = '#eff0f1',
  tertiary100 = '#2d3236',
  tertiary80 = '#6c6f72',
  tertiary20 = '#e0e1e1',
  tertiary10 = '#f7f7f7',
  success100 = '#10866e',
  success10 = '#ecf6f4',
  alert100 = '#d93901',
  alert10 = '#fcf0eb',
  link100 = '#3078bc',
  link10 = '#ebf1f8',
  white100 = '#ffffff',
  /**
   * Old, deprecated colors
   */
  white = '#fff',
  black = '#2d3236',
  gray0 = '#fcfcfc',
  gray1 = '#f1f1f1',
  gray2 = '#d4d5d6',
  gray3 = '#b3b5b6',
  gray4 = '#6c6f72',
  gray5 = 'rgba(47, 64, 80, 1)',
  gray6 = '#7a7879',
  rockWhite = '#e6e5cc',
  chardon = '#ffefec',
  softBlue = '#3078bc',
  softBlueLight = '#e6eef7',
  errorRed = '#cd212a',
  blinkRed = '#ef4156',
  blinkRedHover = '#ff4d62',
  blinkRedActive = '#d63f51',
  blinkRedLight = '#fcd9dd',
  blinkRedSecondaryHover = 'rgba(255, 77, 98, 0.03)',
  blinkRedSecondaryActive = 'rgba(239, 65, 86, 0.12)',
  blinkAltControlHover = 'rgba(48, 120, 188, 0.06)',
  blinkAltControlActive = 'rgba(48, 120, 188, 0.12)',
  mustard = '#ffc439',
  flan = '#ffe1a1',
  blinkYellow = '#fffa6e',
  eggshell = '#fffee2',
  successGreen = '#46b05a',
  successGreenLight = '#e4f3e7',
  gunmetalGray = '#2f4050',
  paleGreen = '#e5f6ec',
  trans50 = 'rgba(0, 0, 0, 0.5)',
  trans40 = 'rgba(0, 0, 0, 0.4)',
  trans36 = 'rgba(45, 50, 54, 0.36)',
  trans28 = 'rgba(0, 0, 0, 0.28)',
  trans25 = 'rgba(0, 0, 0, 0.25)',
  trans20 = 'rgba(0, 0, 0, 0.20)',
  trans15 = 'rgba(0, 0, 0, 0.15)',
  trans14 = 'rgba(0, 0, 0, 0.14)',
  trans12 = 'rgba(0, 0, 0, 0.12)',
  trans10 = 'rgba(0, 0, 0, 0.10)',
  trans8 = 'rgba(0, 0, 0, 0.08)',
  trans5 = 'rgba(0, 0, 0, 0.05)',
  trans2 = 'rgba(0, 0, 0, 0.02)',
  /**
   * Custom colors
   * ! DO NOT ADD COLORS HERE! PLEASE USE SIMILAR COLOR FROM THE PALETTE ABOVE
   */
  customCprV100 = '#fdef68',
}
